<template>
  <div class="ui-categorie">
    <img v-if="index % 2 === 0" :src="category.image_path" />
    <div class="ui-categorie-link">
      <router-link
        :to="{ name: 'CategoryProducts', params: { id: category.id } }"
      >
        {{ category.name }}
      </router-link>
      <p>{{ category.sub_title }}</p>
    </div>
    <img v-if="index % 2 !== 0" :src="category.image_path" />
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="sass">
.ui-categorie
  img
    @apply w-2/4 rounded-lg
  &-link
    background: $accent-color
    @apply flex flex-col justify-around px-1 rounded-r w-2/4
    a
      @apply text-2xl
    p
      @apply text-xl mb-4

@screen sm
  .ui-categorie
    img
      @apply w-full
    &-link
      @apply absolute mb-8 w-10/12 bottom-0 h-16
    p
      @apply hidden
</style>
